import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { openModal, showSignInForm, updateLogoutModalActive } from "../../../redux/slices/formDetails";
import { updateIsLoggedIn } from "../../../redux/slices/user";

import styles from "./styles.module.css";
import Input from "../../Input/input";
import { useState } from "react";
import { updateVideoUrl } from "../../../redux/slices/duonutSettings";
import { updateFromUrlModalActive } from "../../../redux/slices/preview";
import { toggleVideoVisible } from "../../../redux/slices/userActivity";

export default function FromUrl(props) {

   const { fromUrlModalActive } = useSelector((state) => state.preview);
   const [text, setText] = useState('https://www.youtube.com/watch?v=QUk3MNo1Exs')
   const [error, setError] = useState('')
   const dispatch = useDispatch()

   function isValidYoutubeLink(val) {
      let regex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/;
      if (!regex.test(val)) {
         return false
      } else {
         return true
      }
   }

   const handleClose = () => {
      dispatch(updateFromUrlModalActive({ fromUrlModalActive: false }))
   }

   const handleAdd = () => {
      if (!isValidYoutubeLink(text)) return setError('Enter a valid youtube url')
      setError('')
      dispatch(updateVideoUrl({ video_url: text }))
      dispatch(toggleVideoVisible({ videoVisible: true }))
      handleClose()
   }

   return (
      <>
         <AnimatePresence>
            {fromUrlModalActive && (
               <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5, type: "tween", ease: "anticipate" }}
                  className={styles.modal_wrapper}
                  onClick={handleClose}
               >
                  <motion.div
                     initial={{ scale: 0.5 }}
                     animate={{ scale: 1 }}
                     exit={{ scale: 0.5 }}
                     transition={{ duration: 0.5, type: "tween", ease: "anticipate" }}
                     className={styles.content_wrapper}
                     onClick={(e) => e.stopPropagation()}
                  >
                     {/* <h4 className={styles.content__heading}>Log out ?</h4> */}
                     <Input placeholder='Enter a valid video Url'
                        value={text}
                        setValue={setText}
                        errorMsg={error} />
                     <div className={styles.content__button_wrapper}>
                        <button className={` ${styles.button_cancel}`} onClick={handleClose}>
                           Cancel
                        </button>
                        <button className={` ${styles.button_confirm}`} onClick={handleAdd}>
                           Confirm
                        </button>
                     </div>
                     <div className={styles.close_icon} onClick={handleClose}>
                        <img src="/assets/icons/close.svg" alt="" />
                     </div>
                  </motion.div>
               </motion.div>
            )}
         </AnimatePresence>
      </>
   )
}
